import { Component } from 'vue-property-decorator';
import AbstractView from '../abstract-view';

@Component
export default class HomeView extends AbstractView
{
    protected created()
    {
        if (this.$user)
        {
            this.$router.replace({ name: 'dashboard' }).catch();
        }
    }

    /**
     * Returns the login image path for login pop up
     */

    private get loginImage(): string
    {
        return require('@/assets/images/vendor/vertical-plus/login-graphic.png');
    }

    /**
     * Returns the Google logo
     */

    private get googleLogo()
    {
        return require('@/assets/images/vendor/google/logo.svg');
    }

    /**
     * Returns the Google sign in config
     */

    private get googleSignInConfig()
    {
        return {
            apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
            clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
            discoveryDocs: process.env.VUE_APP_GOOGLE_API_DISCOVERY_DOCS.split(','),
            scope: process.env.VUE_APP_GOOGLE_API_SCOPE,
        };
    }

    /**
     * Handles successful logins
     */

    private onLoggedIn()
    {
        let redirectTo = this.$store.getters['authentication/loginRedirectUrl'];

        if (redirectTo)
        {
            this.$store.commit('authentication/loginRedirectUrl', null);
        }
        else
        {
            redirectTo = { name: 'dashboard' };
        }

        this.$router.push(redirectTo).catch();
    }

    private get showLogin(): boolean
    {
        if (this.$user)
        {
            return false;
        }

        return true;
    }
}